/**
 * 公司库存
 *
 * @author Shann <851188611@qq.com>
 */

import {Button, Checkbox, Col, Form, Image, Input, Row, Table} from "antd";
import DataBlock, {DataBlockGrid} from "../DataBlock/DataBlock";
import React, {useState} from "react";
import WarehouseSelect from '@/components/WarehouseSelect/WarehouseSelect';
import Lang from "@components/Lang/Lang";
import "./InventoryCompany.less";

const InventoryCompany = props => {
    /**
     * 查询类型
     */
    const type = 0;

    /**
     * 分页
     */
    const [pagingQuery,setPagingQuery] = useState({
        pageIndex: 1,
        pageSize: 10,
    });
    /**
     * 所有仓库
     */
    const [transitCityIds, setTransitCityIds] = useState(null);
    /**
     * 商品编号
     */
    const [skuNo, setSkuNo] = useState(null);

    /**
     * 剩余库存
     */
    const [isStock, setIsStock] = useState(0);

    /**
     * 正常库存
     */
    const [isNormal, setIsNormal] = useState(0);

    /**
     * 破损库存
     */
    const [isWorn, setIsWorn] = useState(0);

    /**
     * 列表数据
     */
    const dataSource = props.dataSource;

    /**
     * 数据统计
     * @type {{}}
     */
    const dataStatistics = props.dataStatistics || {};

    /**
     * 计量单位
     */
    const Kuan = Lang({id: "Kuan", default: "款"});
    const Xiang = Lang({id: "Xiang", default: "箱"});
    const SouSuo = Lang({id: "SouSuo", default: "搜索"});

    /**
     * 表格栏目
     * @type {[{title: string, render: (function(*, *)), key: string}, {dataIndex: string, title: string}, {dataIndex: string, title: string}, {dataIndex: string, title: string}, {dataIndex: string, title: string}, null]}
     */
    const columns = [
        {
            title: Lang({id: "ShangPin", default: "商品"}),
            key: "goods",
            dataIndex: "goods",
            render: (text, record) => {
                return <Row className="goods-info">
                    <Col className="cover">
                        <Image width={80} height={80} src={record.skuUrl}
                               fallback="data:image/png;base64,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"/>
                    </Col>
                    <Col>
                        <h2>{record.skuName}</h2>
                        <p><Lang id="BianHao">编号</Lang> {record.skuNo}</p>
                        <p><Lang id="ZhuangLiang">装量</Lang> {record.capacity}盒/外箱</p>
                    </Col>
                </Row>
            }
        },
        {
            title: Lang({id: "ZhengChangXiangShu", default: "正常箱数"}),
            dataIndex: "normalStockCount",
            key: "normalStockCount",
        },
        {
            title: Lang({id: "PoSunXiangShu", default: "破损箱数"}),
            dataIndex: "wornStockCount",
            key: "wornStockCount",
        },
        {
            title: Lang({id: "ZongKuCun", default: "总库存"}),
            dataIndex: "stockCount",
            key: "stockCount",
        },
        {
            title: Lang({id: "YiXiaDan", default: "已下单"}) + "-" + Lang({id: "DaiFuKuan", default: "待付款"}),
            dataIndex: "nonPaymentCount",
            key: "nonPaymentCount",
        },
        {
            title: Lang({id: "ShengYuKuCun", default: "剩余库存"}),
            dataIndex: "surplusCount",
            key: "surplusCount",
        }
    ];


    /**
     * 查询参数
     */
    let queryParams = {skuNo, isStock, isNormal, isWorn, type,pagingQuery,transitCityIds}

    /**
     * 分页
     */
    const handlePagination = (pagination) => {
        queryParams.pagingQuery.pageIndex = pagination.current;
        queryParams.pagingQuery.pageSize = pagination.pageSize;
        setPagingQuery(queryParams.pagingQuery)
        props.onQuery(queryParams);
    }

    /**
     * 搜索
     */
    const handleSearch = () => {
        queryParams.pagingQuery.pageIndex = 1;
        setPagingQuery(queryParams.pagingQuery);
        props.onQuery(queryParams);
    }
    /**
     * 渲染视图
     */
    return (
        <div className="InventoryCompany">
            {/* 筛选组件 */}
            <Form className="search" layout="inline">
                <Form.Item>
                    <WarehouseSelect onChange={(dat)=>setTransitCityIds(dat)} />
                </Form.Item>
                <Form.Item label={Lang({id: "ShangPinBianHao", default: "商品编号"})}>
                    <Input placeholder={SouSuo} onChange={(e) => {
                        setSkuNo(e.target.value)
                    }}/>
                </Form.Item>
                <Form.Item>
                    <Checkbox onChange={(e) => {
                        setIsStock(e.target.checked ? 1 : 0)
                    }}><Lang id="ShengYuKuCun">剩余库存</Lang></Checkbox>
                    <Checkbox onChange={(e) => {
                        setIsNormal(e.target.checked ? 1 : 0)
                    }}><Lang id="ZhengChangKuCun">正常库存</Lang></Checkbox>
                    <Checkbox onChange={(e) => {
                        setIsWorn(e.target.checked ? 1 : 0)
                    }}><Lang id="PoSunKuCun">破损库存</Lang></Checkbox>
                </Form.Item>
                <Form.Item>
                    <Button type="text" onClick={handleSearch}><Lang id="SouSuo" default="搜索"/></Button>
                </Form.Item>
            </Form>

            {/* 数据统计 */}
            <DataBlockGrid span="5">
                <DataBlock subject={Lang({id: "ShangPinZongJi", default: "商品总计"}) + `(${Kuan})`} count={dataStatistics.total || 0}/>
                <DataBlock subject={Lang({id: "ShangPinZongKuCun", default: "商品总库存"}) + `(${Xiang})`} count={dataStatistics.stockTotal || 0}/>
                <DataBlock subject={Lang({id: "ZhengChangKuCun", default: "正常库存"}) + `(${Xiang})`} count={dataStatistics.normalStockTotal || 0}/>
                <DataBlock subject={Lang({id: "PoSunKuCun", default: "破损库存"}) + `(${Xiang})`} count={dataStatistics.wornStockTotal || 0}/>
                <DataBlock subject={Lang({id: "KeYongKuCun", default: "可用库存"}) + `(${Xiang}) ${dataStatistics.useStockPercentage || 0}%`} count={dataStatistics.useStockTotal || 0}/>
            </DataBlockGrid>

            {/* 数据列表 */}
            <Table dataSource={dataSource} loading={props.loading} columns={columns} rowKey="skuId" onChange={handlePagination} pagination={{
                defaultPageSize: pagingQuery.pageSize,
                total: props.total,
                current: pagingQuery.pageIndex,
                showSizeChanger: true,
                showQuickJumper: true,
                showTotal: total => `Total ${props.total} items`
            }}/>
        </div>
    );
};

export default InventoryCompany;
